import React, { useEffect, useState, useRef } from 'react';
import gsap from 'gsap';
import styles from './Loader.module.scss';

interface LoaderProps {
  onComplete: () => void;
}

const Loader: React.FC<LoaderProps> = ({ onComplete }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const logoRef = useRef<HTMLHeadingElement>(null);
  const progressRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({
        onComplete: () => {
          gsap.to(containerRef.current, {
            yPercent: -100,
            duration: 1,
            ease: 'power3.inOut',
            onComplete: onComplete
          });
        }
      });

      tl.to(logoRef.current, {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: 'power3.out',
        delay: 0.2
      })
      .to(progressRef.current, {
        width: '100px',
        duration: 1.2,
        ease: 'power2.inOut'
      }, '-=0.5');

    }, containerRef);

    return () => ctx.revert();
  }, [onComplete]);

  return (
    <div className={styles.loaderContainer} ref={containerRef}>
      <div className={styles.logoWrapper}>
        <h1 className={styles.logo} ref={logoRef}>RASH DIGITAL</h1>
        <div className={styles.progressLine} ref={progressRef}></div>
      </div>
    </div>
  );
};

export default Loader;
